import store from 'store2';
import React, { Suspense, lazy, useEffect } from 'react';
import { useCredentialRetreival, VALIDATED } from '@zipit/ls-portal-sdk/dist/logic/useCredentials';

import { removeLoader, setAuthParams } from './utils';

const Components = lazy(async () => {
    const { Components } = await import(/* webpackChunkName: "components", webpackPrefetch: true */ './components');
    return { default: Components };
});

const ORIGIN = window.location.origin;

const App = () => {
    const {
        validationState, validateToken, redirectToLogin, credentials,
        setCredentials, logout, basePath, expired, authHeaders,
        sessionData, setSessionData,
    } = useCredentialRetreival({ isPortal: true, portalOrigins: [ORIGIN] });

    useEffect(() => {
        (async () => {
            setAuthParams();

            const isGuest = window.location?.pathname?.includes('/store');
            const signUp = window.location?.search?.includes('signUp=true');

            let driver = store.get('lsAuthDriver');

            if (isGuest) {
                driver = 'cognito';
                await logout({ skipRedirect: true });
            }

            if (driver) {
                try {
                    await validateToken(driver);
                } catch (err) {
                    console.log(err)
                }
            } else {
                redirectToLogin({ signUp });
            }
        })()
    }, []);

    if (validationState === 'ADMIN_USER_NOT_INITIALIZED') {
        removeLoader();
        window.location.href = '/v2/hosted/zipit/noAuth.html'
    }

    if (validationState === 'END_USER_NOT_INITIALIZED') {
        removeLoader();
        window.location.href = '/v2/hosted/zipit/end-user-noAuth.html'
    }

    if (validationState === VALIDATED) {
        return <Suspense fallback={<></>}>
            <Components credentials={credentials} basePath={basePath} expired={expired} authHeaders={authHeaders}
                redirectToLogin={redirectToLogin} logout={logout} setCredentials={setCredentials}
                sessionData={sessionData} setSessionData={setSessionData}
            />
        </Suspense>
    }

    return null;
};

export default App;
